import { Link } from 'react-router-dom';
import { categories } from '@/mocks/anime';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 pt-14 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-xl text-background-50">51动漫网</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              51动漫网官方品牌主页，汇集51动漫网站与51动漫官网入口，提供日漫、国漫、韩漫等好看漫画的免费在线阅读。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              <a href="#footer-categories">动漫分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              <a href="#footer-links">快速链接</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">
                  首页推荐
                </Link>
              </li>
              <li>
                <Link to="/category/riman" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">
                  日漫专区
                </Link>
              </li>
              <li>
                <Link to="/category/guoman" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">
                  国漫专区
                </Link>
              </li>
              <li>
                <Link to="/category/hanman" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">
                  韩漫专区
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              <a href="#footer-contact">联系我们</a>
            </h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-accent-500"></i>
                <span>contact@51dmw.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-customer-service-line text-accent-500"></i>
                <span>在线客服 7×24小时</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line text-accent-500"></i>
                <span>中国·北京</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} <strong>51动漫网</strong> 版权所有 | 51动漫网站 51动漫官网 51动漫官方网站
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-accent-400 transition-colors whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-accent-400 transition-colors whitespace-nowrap" rel="nofollow">
              用户协议
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-accent-400 transition-colors whitespace-nowrap" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}